import axiosHelper from './axiosHelper';
import axios from './axios';

export default {
  fetchUserEvents(userId: string) {
    return axios
      .post('/api/fetch_ticketed_events', { userId })
      .then((resp: any) => resp.data);
  },
  fetchRecentOrders(body: any) {
    return axios
      .post('/api/fetch_purchased_orders', body)
      .then((resp: any) => resp.data);
  },
  exportOrder(body: any) {
    return axios
      .post('/api/request_attendees_report', body)
      .then((resp: any) => resp.data);
  },
  searchOrders(body: any) {
    return axios
      .post('/api/fetch_purchased_orders', body)
      .then((resp: any) => resp.data);
  },
  scanResult(body: any) {
    return axios.post('/api/scan_ticket_order', body).then((resp: any) => {
      return resp.data;
    });
  },
  addOwner(body: any) {
    return axios
      .post('/api/generate_event_ownership', body)
      .then((resp: any) => {
        return resp.data;
      });
  },
  getPayment(body: any) {
    return axios.post('/api/request_payout', body).then((resp: any) => {
      return resp.data;
    });
  },
  scanticket(body: any) {
    return axios.post('/api/scan_sold_ticket', body).then((resp: any) => {
      return resp.data;
    });
  },
  exportFood(body: any) {
    return axios
      .post('/api/request_foodVendor_report', body)
      .then((resp: any) => resp.data);
  },
  attendeeReport(body: any) {
    return axios
      .post('/api/request_attendees_report', body)
      .then((resp: any) => resp.data);
  },
  paginatedEventDetail(body: any) {
    return axios
      .post('/api/fetch_pagianted_ticketed_event_detail', body)
      .then((resp: any) => resp.data);
  },
  paginatedEventRecords(body: any) {
    return axios
      .post('/api/fetch_pagianted_ticketed_events', body)
      .then((resp: any) => resp.data);
  },
  waitingListRecords(body: any) {
    return axios
      .post('/api/fetchWaitListRequests', body)
      .then((resp: any) => resp.data);
  },
  approve(body: any) {
    return axios
      .post('/api/approve_request', body)
      .then((resp: any) => resp.data);
  },
  resend(body: any) {
    return axios
      .post('/api/resend_ticket_order', body)
      .then((resp: any) => resp.data);
  },
  reIssue(body: any) {
    return axios
      .post('/api/reissue_ticket_order_to_new_user', body)
      .then((resp: any) => resp.data);
  },
  cTicket(body: any) {
    return axios
      .post('/api/issue_complimentary_ticket', body)
      .then((resp: any) => resp.data);
  },
};
